import { render, staticRenderFns } from "./today_food.vue?vue&type=template&id=3da520a9&scoped=true"
import script from "./today_food.vue?vue&type=script&lang=js"
export * from "./today_food.vue?vue&type=script&lang=js"
import style0 from "./today_food.vue?vue&type=style&index=0&id=3da520a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da520a9",
  null
  
)

export default component.exports